import type { DeepPartial, ParticleSystem } from "@/types";

/**
 * Partial overrides for particle systems.
 * Lookup by set id and particle system name.
 */
export const particleSystemOverrides: Record<
  string,
  Record<string, DeepPartial<ParticleSystem>>
> = {
  // Dice of Enlightenment
  // The manifest has transparencyMode: 3 on phong1 material, but we override it to 1 in
  // manifestOverrides to fix a different issue. transparencyMode: 1 keeps depthWrite: true
  // on the dice, which causes a weird interaction with particles that have depthTest: false
  // (blendMode: 2) - they render on top of the dice regardless of draw order.
  // To keep the transparencyMode: 1 override, we change particles to blendMode: 1 (standard)
  // which enables depthTest: true, allowing particles to correctly render behind the dice.
  "02501": {
    stars: {
      blendMode: 1,
    },
    beams: {
      blendMode: 1,
    },
  },
};
